import { HeaderService } from '@patsnap-utils/biz';
import { reactive } from 'vue';

export const headerService = reactive(new HeaderService()) as HeaderService;
